export default [
	{
		year: 1979,
		value: 7.19,
    alt: 12,
    group: 'apples'
	},
	{
		year: 1980,
		value: 7.83,
    alt: 15,
    group: 'apples'
	},
	{
		year: 1981,
		value: 7.24,
    alt: 17,
    group: 'apples'
	},
	{
		year: 1982,
		value: 7.44,
    alt: 28,
    group: 'apples'
	},
	{
		year: 1983,
		value: 7.51,
    alt: 23,
    group: 'apples'
	},
	{
		year: 1984,
		value: 7.1,
    alt: 17,
    group: 'apples'
	},
	{
		year: 1985,
		value: 6.91,
    alt: 11,
    group: 'apples'
	},
	{
		year: 1986,
		value: 7.53,
    alt: 13,
    group: 'apples'
	},
	{
		year: 1987,
		value: 7.47,
    alt: 18,
    group: 'apples'
	},
	{
		year: 1988,
		value: 7.48,
    alt: 20,
    group: 'apples'
	},
	{
		year: 1989,
		value: 7.03,
    alt: 24,
    group: 'apples'
	},
	{
		year: 1990,
		value: 6.23,
    alt: 26,
    group: 'bananas'
	},
	{
		year: 1991,
		value: 6.54,
    alt: 16,
    group: 'bananas'
	},
	{
		year: 1992,
		value: 7.54,
    alt: 25,
    group: 'bananas'
	},
	{
		year: 1993,
		value: 6.5,
    alt: 28,
    group: 'bananas'
	},
	{
		year: 1994,
		value: 7.18,
    alt: 11,
    group: 'bananas'
	},
	{
		year: 1995,
		value: 6.12,
    alt: 19,
    group: 'bananas'
	},
	{
		year: 1996,
		value: 7.87,
    alt: 14,
    group: 'bananas'
	},
	{
		year: 1997,
		value: 6.73,
    alt: 22,
    group: 'bananas'
	},
	{
		year: 1998,
		value: 6.55,
    alt: 13,
    group: 'bananas'
	},
	{
		year: 1999,
		value: 6.23,
    alt: 30,
    group: 'bananas'
	},
	{
		year: 2000,
		value: 6.31,
    alt: 27,
    group: 'bananas'
	},
	{
		year: 2001,
		value: 6.74,
    alt: 13,
    group: 'cherries'
	},
	{
		year: 2002,
		value: 5.95,
    alt: 18,
    group: 'cherries'
	},
	{
		year: 2003,
		value: 6.13,
    alt: 15,
    group: 'cherries'
	},
	{
		year: 2004,
		value: 6.04,
    alt: 11,
    group: 'cherries'
	},
	{
		year: 2005,
		value: 5.56,
    alt: 29,
    group: 'cherries'
	},
	{
		year: 2006,
		value: 5.91,
    alt: 26,
    group: 'cherries'
	},
	{
		year: 2007,
		value: 4.29,
    alt: 10,
    group: 'cherries'
	},
	{
		year: 2008,
		value: 4.72,
    alt: 14,
    group: 'cherries'
	},
	{
		year: 2009,
		value: 5.38,
    alt: 21,
    group: 'cherries'
	},
	{
		year: 2010,
		value: 4.92,
    alt: 20,
    group: 'cherries'
	},
	{
		year: 2011,
		value: 4.61,
    alt: 24,
    group: 'dates'
	},
	{
		year: 2012,
		value: 3.62,
    alt: 19,
    group: 'dates'
	},
	{
		year: 2013,
		value: 5.35,
    alt: 12,
    group: 'dates'
	},
	{
		year: 2014,
		value: 5.28,
    alt: 13,
    group: 'dates'
	},
	{
		year: 2015,
		value: 4.63,
    alt: 28,
    group: 'dates'
	},
	{
		year: 2016,
		value: 4.72,
    alt: 30,
    group: 'dates'
	}
];